import { FC, useState } from 'react';
import { Box, Text, Flex, Switch } from '@chakra-ui/react';
import { useMutation } from '@apollo/client';
import { ElementDisplay } from '../models';
import { UPDATE_ELEMENT_DISPLAY } from '../mutations';
import { GET_ELEMENTS_DATA } from '../queries';

type ElementDisplayItemProps = {
  display: ElementDisplay;
};

const ElementDisplayItem: FC<ElementDisplayItemProps> = ({ display }) => {
  const [active, setActive] = useState(display.active);
  const [updateDisplay] = useMutation(UPDATE_ELEMENT_DISPLAY, {
    refetchQueries: [{ query: GET_ELEMENTS_DATA }],
  });

  const handleToggleVisibility = (checked: boolean) => {
    setActive(checked);
    updateDisplay({
      variables: {
        updateInput: {
          id: display.id,
          active: checked,
        },
      },
    });
  };
  return (
    <Box
      p="4"
      rounded="md"
      boxShadow="md"
      _hover={{ transform: 'scale(1.01)' }}
    >
      <Flex alignItems="center" gridGap="2">
        <Text fontSize="sm" fontStyle="italic">
          {display.name}
        </Text>
        <Switch
          size="sm"
          isChecked={active}
          onChange={e => handleToggleVisibility(e.target.checked)}
        />
      </Flex>
    </Box>
  );
};

export default ElementDisplayItem;
